import {atom} from "recoil";
import {SelectElementModelFE} from "../api/types/generic";

export const locationGroupAtom = atom<SelectElementModelFE[]>({
    key: "locationGroupAtom",
    default: []
});

export const locationGroupsAtom = atom<SelectElementModelFE[]>({
    key: "locationGroupsAtom",
    default: []
});